// import Vue from 'vue';
import VueMaterial from 'vue-material';
import VueRouter from 'vue-router';
import vueMoment from 'vue-moment';
import VueClipboards from 'vue-clipboards';

export default (Vue, ...params) => {
  params.filter(el => typeof el === 'object')
    .map(le => Vue.use(le));
  Vue.use(VueMaterial);
  Vue.use(VueRouter);
  Vue.use(vueMoment);
  Vue.use(VueClipboards);
};



// WEBPACK FOOTER //
// ./src/config/plugins.js